export default "/_next/static/images/subscribePromptWrapper2-93753e5035d19c6717b845436ee01a6a.png";